import {Component, OnInit, ViewChild} from '@angular/core';
import {DataService} from '../../services/data.service';
import {Option} from '../../classes/option';
import {GroupListComponent} from '../../components/groupList/groupList.component';
import {StorageService} from '../../services/storage.service';
import {Product} from '../../classes/product';
import {OptionItem} from '../../classes/optionItem';
import {ResultListComponent} from '../resultList/resultList.component';

@Component({
  selector: 'app-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.css']
})
export class DefaultComponent implements OnInit {
  options: any = {};
  products: Product[] = Array();
  @ViewChild(GroupListComponent, {read: true, static: false})
  private groupListComponent: GroupListComponent;
  protected product = 'default';

  constructor(private dataService: DataService, private storageService: StorageService) {
  };

  ngOnInit(): void {
    // clear products
    this.products = [];
    this.storageService.showAbleProductCount = 0;
    this.storageService.product = this.product;
    this.dataService.getOptions(this.product).then((result) => {
      const options = result.result;
      for (const option in options) {
        if (options.hasOwnProperty(option)) {
          this.options[option] = new Option(options[option]);
        }
        if (this.options[option].sort) {
          this.options[option].subItems.sort(this.dataService.compareOptions);
        }
      }
      this.storageService.options = this.options;
      this.dataService.getPrograms(this.product).then((result) => {
        const products = result.result;
        this.storageService.products = [];
        for (const product in products) {
          if (products.hasOwnProperty(product)) {
            if (products[product].programs) {
              const productObject = new Product(products[product], this.storageService);
              this.storageService.products.push(productObject);
            }
          }
        }
        ;
        this.storageService.products.sort(this.dataService.compareProducts);
        this.products = this.storageService.products;
        this.storageService.updateOptions();
      });
    });
  }

}
